"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const oilyskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-oilyskin` : '') + (description ? ` desc-oilyskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-oilyskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-oilyskin"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_26120_2663)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M.21 16c.22.36.68.46 1.03.25L3.9 14.6c1.45-.9 3.34-.8 4.7.25a5.61 5.61 0 0 0 6.85 0 4.09 4.09 0 0 1 4.6-.3l2.8 1.66a.75.75 0 0 0 .76-1.29l-2.8-1.66a5.59 5.59 0 0 0-6.28.4 4.11 4.11 0 0 1-5.01 0 5.66 5.66 0 0 0-6.41-.33L.46 14.97A.75.75 0 0 0 .2 16Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.46 19.65a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 19.65a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.53 19.65a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.46 23.4a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.27 23.4a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.77 23.4a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.56 23.4a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.03 12.65a4.13 4.13 0 0 0 4.12-4.13c0-1.4-.62-3.05-1.29-4.45a30.31 30.31 0 0 0-1.5-2.75l-.39-.6a1.12 1.12 0 0 0-.28-.3l-.12-.08-.13-.06a1.13 1.13 0 0 0-.27-.07L12.03.2c-.14 0-.28.03-.41.08l-.13.06c-.17.09-.3.22-.4.37-.43.67-1.22 1.94-1.9 3.36-.66 1.4-1.29 3.05-1.29 4.45v.2a4.13 4.13 0 0 0 4.13 3.93Zm0-1.5a2.63 2.63 0 0 1-2.61-2.37l-.02-.26c0-1.04.5-2.43 1.15-3.8a28.9 28.9 0 0 1 1.48-2.69c.42.68.98 1.64 1.48 2.69.65 1.37 1.14 2.76 1.14 3.8a2.63 2.63 0 0 1-2.36 2.61l-.26.02Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_26120_2663"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = oilyskin;